<template>
  <section class="SectionHeadlineImage" :class="background">
    <Wrap>
      <Headline>
        {{ headline }}
      </Headline>
      <Markdown class="head" :markdown="head" />
      <Row>
        <Column :lg="8" :sm="6">
          <Pic class="image" :src="imageSrc" />
        </Column>
        <Column :lg="4" :sm="6">
          <Markdown class="side" :markdown="side" />
        </Column>
      </Row>
    </Wrap>
  </section>
</template>

<script>
const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  components: { Markdown },
  props: {
    background: { type: String, default: 'white' },
    head: String,
    headline: String,
    imageSrc: String,
    side: String,
  },
}
</script>

<style lang="scss">
.SectionHeadlineImage {
  .head {
    margin-bottom: 4rem;
    text-align: center;

    p {
      font-size: $h4;
    }

    strong {
      color: $main;
      font-weight: $semibold;
    }
  }

  .image img {
    width: 100%;
    @include sm {
      padding-right: 2rem;
    }
  }

  .side {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
}
</style>
